import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 1.333C6.125 1.333 1.333 6.125 1.333 12S6.125 22.667 12 22.667 22.667 17.875 22.667 12 17.875 1.333 12 1.333zm0 20.285A9.612 9.612 0 0 1 2.383 12 9.612 9.612 0 0 1 12 2.383 9.612 9.612 0 0 1 21.617 12 9.612 9.612 0 0 1 12 21.617z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 7.415c.49 0 .874-.384.874-.874A.866.866 0 0 0 12 5.667a.866.866 0 0 0-.874.874c0 .49.384.874.874.874z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.333 18V9.333h1.334V18h-1.334z",
			fill: "currentColor"
		})
	]
});
export default SvgInfo;
